import Router from '../Router';
import { PriceRevealController } from '../../controllers';
// import { Secret } from '../../utils';

// const
// 	IS_PRE_SEASON = Secret.is_passed ? false : JSON.parse(process.env.IS_PRE_SEASON),
// 	preventAnyOtherPages = IS_PRE_SEASON ? { '*any': 'redirectToPricePage' } : null;

export default class PriceRevealRouter extends Router {
	constructor(args) {
		super(args);

		/**
		 * All routes doesn't required for auth
		 * @type {boolean}
		 */
		this.authOnlyDefault = false;
	}

	initialize(options) {
		this.controller = new PriceRevealController(options);
	}

	get appRoutes() {
		return {
			'2018-price-reveal': 'priceReveal',
			// ...preventAnyOtherPages
		};
	}
}